import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton, Paper } from '@mui/material';
import i18n from '../../../../../utils/i18n';
/* import placeholder from '../../../../../images/icons/placeholder-new.png'; */
import CustomButton from '../../../../components/CustomButton';
import classes from '../ClientSection.module.scss';

export default function RequestList({ data, status, ...props }) {
	const [itemsToShow, setItemsToShow] = React.useState(2);
	const isMobile = window.innerWidth < 480;

	// Safety check: ensure data is an array
	if (!data || !Array.isArray(data) || data.length === 0) {
		return null;
	}

	return (
		<div key={props.key}>
			<Accordion
				defaultExpanded={status === 'open' ? true : false}
				sx={{
					boxShadow: 'none',
					'& .css-gp17v7-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded':
						{
							borderRadius: '8px',
						},
					'.css-gp17v7-MuiButtonBase-root-MuiAccordionSummary-root': {
						borderRadius: '8px',
					},
				}}>
				<AccordionSummary
					sx={{ bgcolor: '#f0f4ff', color: '#1c32f3', boxShadow: 'none' }}
					expandIcon={
						<IconButton
							style={{ background: 'white', padding: 0 }}
							size='large'>
							<ExpandMoreIcon sx={{ color: '#2D46B9', fontSize: '32px' }} />
						</IconButton>
					}
					aria-controls='panel1a-content'
					id='panel1a-header'>
					<Typography className={classes.heading}>
						{props.title}
						{/*             <img alt='' src={placeholder} className='Icon16 MarginVertical' /> */}
					</Typography>
				</AccordionSummary>
				<AccordionDetails sx={{ boxShadow: 'none' }}>
					<Paper className='ReqListPaper' elevation={0}>
						{data.map((item, i) => {
							if (i < itemsToShow) {
								return (
									<div className={classes.ReqListItem} key={i}>
										<p>{item.email}</p>
										<span
											style={{
												marginBottom: isMobile ? '16px' : '0px',
											}}>
											{item.timePassed <= 24
												? `${item.timePassed} ${i18n.t(
														'providerdashboard.hours'
												  )}`
												: `${Math.floor(item.timePassed / 24)} ${i18n.t(
														'providerdashboard.days'
												  )}`}
											{/*      <img src={placeholder} alt='' className='Icon16' /> */}
										</span>
										<div
											style={{
												marginBottom: isMobile ? '16px' : '0px',
											}}>
											<CustomButton
												//iconSrc={IconPlus}
												buttonColor='#1c32f3'
												hoverColor='#0036cc'
												titleColor='#ffffff'
												titleHoverColor='#e0e0e0'
												width='100%'
												height='44px'
												padding='12px'
												onClick={() => {
													props.handleSelect(item);
												}}
												buttonName={i18n.t('providerdashboard.checkingthis')}
											/>
										</div>
									</div>
								);
							} else return null;
						})}
					</Paper>
					{data.length > 2 ? (
						<div
							style={{
								marginTop: '10px',
								cursor: 'pointer',
								border: '1px solid #1c32f3',
								backgroundColor: 'azure',
								width: 'fit-content',
								display: 'flex',
								justifyContent: 'center',
								borderRadius: '8px',
								padding: '0 6px',
							}}
							onClick={() => {
								let nr = itemsToShow > 2 ? 2 : data.length;
								setItemsToShow(nr);
							}}>
							<p style={{ fontSize: '12px !important' }}>
								{itemsToShow > 2
									? i18n.t('general.backbutton')
									: i18n.t('general.forwardbutton')}
							</p>
							{/*      <img src={placeholder} alt='' className='Icon16' /> */}
						</div>
					) : null}
				</AccordionDetails>
			</Accordion>
			<div style={{ margin: '24px' }}></div>
		</div>
	);
}
